import { BrowserRouter, createBrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store';
import reportWebVitals from './reportWebVitals';

import './i18n';
import './styles/globals.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('react-pallet-canvas');

// Remove the router configuration with future flags since it's causing TypeScript errors
// and we're using BrowserRouter anyway

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter >
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found. Please check your HTML.');
}

reportWebVitals();
